export default {
  name: 'DisclosureFooter'
};